import { concatMap, map, Observable } from "rxjs";
import { UserToken } from "../../../model/User/UserToken";
import generateSecureToken from "../../../utils/generateSecureToken";
import { apiService } from "../../ApiService";

export type GoogleCreateUserOpt = {
  attribution?: Record<string, string>;
  birthDate?: string;
  newsletter?: boolean;
  sessionID?: string;
};

export interface GoogleCredential {
  code?: string;
  token?: string;
}

export const googleCreate = (
  cred: GoogleCredential,
  opts?: GoogleCreateUserOpt,
): Observable<UserToken> => {
  const { code, token } = cred;
  return generateSecureToken(apiService.userAgent).pipe(
    concatMap((secureToken) => {
      return (
        apiService.post({
          path: `v1/store/google_play/account`,
          body: { token, code, ...opts },
          secureToken: secureToken,
        }) as Observable<UserToken>
      ).pipe(
        map((token: UserToken) => {
          apiService.familyToken = token.familyToken;
          apiService.userToken = token.userToken;
          return token;
        }),
      ) as Observable<UserToken>;
    }),
  ) as Observable<UserToken>;
};
